export const AUTH_SCHEME = 'authScheme';
export const API_KEY_SETTINGS = 'apiKeySettings';
export const SECRET_NAME = 'secretName';
export const NAME = 'name';
export const LOCATION = 'location';